import { render, staticRenderFns } from "./FilterTabs.vue?vue&type=template&id=bdf85944&scoped=true&"
import script from "./FilterTabs.vue?vue&type=script&lang=js&"
export * from "./FilterTabs.vue?vue&type=script&lang=js&"
import style0 from "./FilterTabs.vue?vue&type=style&index=0&id=bdf85944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf85944",
  null
  
)

export default component.exports